export const GET_PAYMENT_REQUEST = 'GET_PAYMENT_REQUEST'
export const GET_PAYMENT_REQUEST_PENDING = 'GET_PAYMENT_REQUEST_PENDING'
export const GET_PAYMENT_REQUEST_SUCCESS = 'GET_PAYMENT_REQUEST_SUCCESS'
export const GET_PAYMENT_REQUEST_ERROR = 'GET_PAYMENT_REQUEST_ERROR'
